window.addEventListener('DOMContentLoaded', () => {
  const stickyATC = document.querySelector('#lumin-sticky-atc');
  if (!stickyATC) return;

  const img = stickyATC.querySelector('.product-content img');
  const btn = stickyATC.querySelector('[name="add"]');
  const selectField = stickyATC.querySelector('select[name="id"]');
  const compareEl = stickyATC.querySelector('[data-sticky-compare]');
  const saleEl = stickyATC.querySelector('[data-sticky-sale]');
  const desktopPriceEl = stickyATC.querySelector('[data-sticky-price-desktop]');
  const quantityWrapper = stickyATC.querySelector('quantity-input');
  const stickyForm = stickyATC.querySelector('product-form.sticky-atc');
  const mainFormId = stickyForm?.dataset.mainFormId;
  const mainSubmitId = stickyForm?.dataset.mainSubmitId;
  const mainSubmitBtn = mainSubmitId ? document.getElementById(mainSubmitId) : null;
  const supplyEl = document.querySelector('.glowe-supply[data-gift-variant-id], .glowe-supply');
  const mainAddBtn = document.querySelector('product-form:not(.sticky-atc) [name="add"]');

  if (supplyEl) {
    stickyATC.classList.add('glowe-bundle-page');
    if (quantityWrapper) {
      quantityWrapper.closest('.quantity-input-wrapper')?.classList.add('sticky-atc-qty--hidden');
    }
  }

  function getSelectedBundleCard() {
    if (!mainFormId) return null;
    const selected = document.querySelector(
      `input[type="radio"][name="quantity"][form="${mainFormId}"]:checked`
    );
    if (!selected) return null;
    return document.querySelector(`label[for="${selected.id}"]`);
  }

  function syncStickyPricing() {
    const card = getSelectedBundleCard();
    const compareTarget = card?.querySelector('.glowe-supply__compare, .glowe-simple-offer__compare, .quantity-break__compare');
    const saleTarget = card?.querySelector('.glowe-supply__price, .glowe-simple-offer__price, .quantity-break__price');

    if (!card) {
      const simpleOffer = document.querySelector('.glowe-simple-offer');
      if (simpleOffer) {
        const simpleCompare = simpleOffer.querySelector('.glowe-simple-offer__compare');
        const simpleSale = simpleOffer.querySelector('.glowe-simple-offer__price');
        if (simpleSale && saleEl) {
          const saleText = simpleSale.textContent.trim();
          const compareText = simpleCompare?.textContent.trim() || '';
          saleEl.textContent = saleText;
          if (compareEl) {
            compareEl.textContent = compareText;
            compareEl.hidden = !compareText || compareText === saleText;
          }
          if (desktopPriceEl) {
            const snippetCompare = desktopPriceEl.querySelector('.price-item--regular s, s.price-item--regular');
            const snippetSale = desktopPriceEl.querySelector('.price-item--sale, .price-item--last');
            if (snippetCompare) snippetCompare.textContent = compareText;
            if (snippetSale) snippetSale.textContent = saleText;
          }
          return;
        }
      }
    }

    if (compareTarget && saleTarget && compareEl && saleEl) {
      const compareText = compareTarget.textContent.trim();
      const saleText = saleTarget.textContent.trim();
      compareEl.textContent = compareText;
      saleEl.textContent = saleText;
      compareEl.hidden = !compareText || compareText === saleText;

      if (desktopPriceEl) {
        const snippetCompare = desktopPriceEl.querySelector('.price-item--regular s, s.price-item--regular');
        const snippetSale = desktopPriceEl.querySelector('.price-item--sale, .price-item--last');
        if (snippetCompare) snippetCompare.textContent = compareText;
        if (snippetSale) snippetSale.textContent = saleText;
      }
      return;
    }

    const mainPrice = document.querySelector(
      `#ProductInfo-${stickyATC.closest('[data-section]')?.dataset.section || ''} .price, .product__info-container .price`
    );
    if (!mainPrice) return;

    const mainCompare = mainPrice.querySelector('s.price-item--regular, .price__sale s');
    const mainSale = mainPrice.querySelector('.price-item--sale, .price-item--last');

    if (mainCompare && compareEl) {
      compareEl.textContent = mainCompare.textContent.trim();
      compareEl.hidden = false;
    }
    if (mainSale && saleEl) {
      saleEl.textContent = mainSale.textContent.trim();
    }
  }

  function bindBundlePriceSync() {
    if (!mainFormId) return;

    document
      .querySelectorAll(`input[type="radio"][name="quantity"][form="${mainFormId}"]`)
      .forEach((input) => {
        input.addEventListener('change', syncStickyPricing);
      });

    document.querySelectorAll('.glowe-supply__card, .quantity-break').forEach((card) => {
      card.addEventListener('click', () => requestAnimationFrame(syncStickyPricing));
    });

    syncStickyPricing();
  }

  const thresholdEl = mainAddBtn || document.querySelector('button[name="add"]');
  const threshold =
    (thresholdEl?.getBoundingClientRect().bottom || 0) + Number(stickyATC.dataset.offset || 0);

  window.addEventListener('scroll', () => {
    if (window.scrollY > threshold) {
      stickyATC.classList.add('show');
      document.documentElement.style.paddingBottom = `${stickyATC.clientHeight}px`;
      document.documentElement.style.height = 'auto';
    } else {
      stickyATC.classList.remove('show');
      document.documentElement.style.paddingBottom = '0';
    }
  });

  if (selectField && img) {
    selectField.addEventListener('change', () => {
      img.setAttribute('src', selectField.options[selectField.selectedIndex].dataset.img);
    });
  }

  document.querySelector('.product-form:not(.sticky-atc) [name="id"]')?.addEventListener('change', (e) => {
    const value = Number(e.target.value);
    if (value && selectField) {
      selectField.value = value;
    }
  });

  bindBundlePriceSync();

  // Single add path: the sticky button submits its form, which we proxy to the
  // main product form's submit button. The separate click handler below was
  // redundant (the button is type=submit, so it always fires this submit too)
  // and caused a second add on bundle pages.
  stickyForm?.querySelector('form')?.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!mainSubmitBtn) return;
    mainSubmitBtn.click();
  });
});
